import MisDatosPage from 'pages/MisDatos';
import HomeSpecialist from 'pages/Specialist/Home/Home';
import OrderDetail from 'pages/Specialist/OrderDetail';
import MaintanceReports from 'pages/Specialist/MaintanceReports';
import AttentionVoucher from 'pages/Specialist/AttentionVoucher';
import FinishOrderForm from 'components/specialist/Order/FinishOrderForm';
import FormFinishMaintanceReport from 'components/specialist/MaintanceReports/FormFinishMaintanceReport/FormFinishMaintanceReport';
import Test from 'pages/Specialist/Test';
import SpecialistOrders from 'pages/Specialist/SpecialistOrders';
import OneMaintanceReport from 'pages/Specialist/OneMaintanceReport';
import Mantencion from 'pages/Specialist/mantenciones/Mantencion';
import RedirectLegacyMantencion from 'pages/Specialist/mantenciones/RedirectLegacyMantencion';
import IDClientePageSpecialist from 'pages/Specialist/IDClientePage';
import EdificiosPage from 'features/Especialistas/Pages/Edificios/EdificiosPage';
import VisitasListPage from 'pages/Specialist/VisitasList/VisitasListPage';
import VisitaEditorPage from 'pages/Specialist/VisitaEditor/VisitaEditorPage';
import IniciarSolicitudPage from 'pages/Specialist/IniciarSolicitudPage';
import MisTareasPage from 'pages/Specialist/MisTareasPage';

import { mainRoute, catchAllRoute } from '../helpers';

const especialistaRoutes = [
  mainRoute('/specialist', HomeSpecialist),
  mainRoute('/specialist/mantenciones/:id', Mantencion),
  mainRoute('/specialist/solicitudes/:id/iniciar', IniciarSolicitudPage),
  mainRoute('/', HomeSpecialist),
  mainRoute('/specialist/AttentionVoucher', AttentionVoucher),
  // Ruta legacy sin gate de checklist (bug #9a): redirige al flujo vivo gateado.
  mainRoute('/specialist/lista-mantenciones/:idMantencion', RedirectLegacyMantencion),
  mainRoute('/specialist/order', SpecialistOrders),
  mainRoute('/specialist/mis-tareas', MisTareasPage),
  mainRoute('/specialist/order/:id', OrderDetail),
  mainRoute('/specialist/order/:id/finish-form', FinishOrderForm),
  mainRoute('/specialist/maintanceReports', MaintanceReports),
  mainRoute('/specialist/maintanceReports/:id', OneMaintanceReport),
  mainRoute('/specialist/maintanceReports/:id/finish-form', FormFinishMaintanceReport),
  mainRoute('/specialist/edificios', EdificiosPage),
  mainRoute('/specialist/edificios/:id', IDClientePageSpecialist),
  mainRoute('/specialist/visitas', VisitasListPage),
  mainRoute('/specialist/visitas/nueva', VisitaEditorPage),
  mainRoute('/specialist/visitas/:id', VisitaEditorPage),
  mainRoute('/specialist/test', Test),
  // Ley 21.719: toda persona con cuenta puede ejercer sus derechos sobre sus datos.
  mainRoute('/mis-datos', MisDatosPage),
  catchAllRoute(),
];

export default especialistaRoutes;
